import React, { memo } from 'react';
import { Button } from 'appkit-react';

import { useDispatch, useSelector } from 'react-redux';

import { insightModals, INSIGHT_FIELDS } from '@model';
import actions from '@flux/action';
import alert from '@components/alert';
// import PropTypes from 'prop-types';

// import '@style/modules/insights/analysisInsightDetail.scss';
import '../../../../styles/modules/analysis/analysisRight.scss';
import { splitCamelCaseString } from '@utils/widget';
import RichEditor from '@modules/questionnaires/complexity/richEditor';

const Actions = ({ onDelete, onEdit, loading }) => {
  const handleDelete = () => {
    alert.confirm({ onOk: onDelete });
  };
  return (
    <div className="action-wrapper">
      <Button
        isLoading={loading}
        size="lg"
        kind="secondary"
        onClick={handleDelete}
        className="role-control"
      >
        Delete
      </Button>

      <Button
        isLoading={loading}
        onClick={onEdit}
        size="lg"
        kind="primary"
        className="role-control"
      >
        Edit
      </Button>
    </div>
  );
};

const Section = memo(({ title, data, className = '' }) => (
  <div className="insight-modal-detail-section">
    <div className="label">{title}</div>
    <div className={`insight-detail-text ${className}`}>{data || '-'}</div>
  </div>
));

function InsightDetail({
  changeConfig,
  currentDetail = {},
  className,
  goBack,
  isActionLoading,
  toggleActionLoading,
  // fetchListhData,
  shouldShowGoBack = true,
  field = INSIGHT_FIELDS.ANALYSIS,
  afterDelete = () => {},
  ...restProps
}) {
  const {
    // id,
    // projectId,
    // segmentName,
    insightId,
    category: { displayCategory = '' } = {},
    title,
    summary,
    [field]: insight,
  } = currentDetail;

  const companyInstance = useSelector(
    (state) => state.common.projectCompanyInfo.companyInstance,
  );

  const shouldHideSummaryIfIsGuidingP = field === 'guidingPrinciple';

  const dispatch = useDispatch();

  const _goBack = (config = {}) => {
    changeConfig({
      type: insightModals.INSIGHT_LIST,
      ...config,
    });
  };

  const handleDelete = async () => {
    toggleActionLoading(true);
    const result = await dispatch(
      actions.handleInsightModalDelete({
        insightId,
        segment: restProps.segment,
        category: restProps.category,
        uuid: restProps.uuid,
        field,
        companyInstance,
      }),
    );

    if (result?.success) {
      changeConfig({ isUpdated: true });
      (goBack || _goBack)();
    }

    toggleActionLoading(false);
    afterDelete();
  };

  const handleEdit = () => {
    changeConfig({
      type:
        field === INSIGHT_FIELDS.ANALYSIS
          ? insightModals.INSIGHT_FORM
          : insightModals.G_PRINCIPLES_FORM,
      isEdit: true,
      from:
        field === INSIGHT_FIELDS.ANALYSIS
          ? insightModals.INSIGHT_DETAIL
          : insightModals.G_PRINCIPLE_DETAIL,
      field,
    });
  };
  const isInternal = JSON.parse(
    window.localStorage.userInfo || '{}',
  ).isInternal;
  return (
    <div className={`analysis-insight-detail ${className}`}>
      {shouldShowGoBack ? (
        <div className="insight-modal-header">
          <div className="insight-modal-back">
            <span onClick={goBack || _goBack}>
              <span className="appkiticon backicon icon-left-chevron-fill " />
              <span> Back to List</span>
            </span>
          </div>
        </div>
      ) : null}

      <div className="insight-modal-header insight-detail-title">
        <RichEditor
          readOnly={true}
          value={title || '-'}
          key={title}
          onInitialContentChange={Boolean(title)}
          linkPopoverProps={{
            placement: 'leftTop',
            getPopupContainer: () =>
              document.getElementsByClassName('insight-modal-overlay')[0] ||
              document.body,
          }}
        />
      </div>

      <div className="insight-modal-content">
        {shouldHideSummaryIfIsGuidingP ? null : (
          <Section title="summary" data={summary} />
        )}
        {field === INSIGHT_FIELDS.ANALYSIS ? (
          <>
            <Section
              title="Connected data"
              data={displayCategory.replace('_', '/')}
            />
            <div className="divider-horizontal" />{' '}
          </>
        ) : null}
        <div className="label">
          {shouldHideSummaryIfIsGuidingP
            ? 'description'
            : splitCamelCaseString(field)}
        </div>
        <RichEditor
          readOnly={true}
          value={insight || '-'}
          onInitialContentChange={Boolean(insight)}
          key={insight}
          linkPopoverProps={{
            placement: 'leftTop',
            getPopupContainer: () =>
              document.getElementsByClassName('insight-modal-overlay')[0] ||
              document.body,
          }}
        />
      </div>
      {isInternal && (
        <Actions
          onEdit={handleEdit}
          onDelete={handleDelete}
          loading={isActionLoading}
        />
      )}
    </div>
  );
}

// InsightDetail.propTypes = {};

export default memo(InsightDetail);
